<template>
  <div class="zodiac-ranking flex flex-wrap overflow-hidden">
    <div class="ranking-col-1 flex flex-col">
      <div v-for="idx in 5" :key="idx" class="contender-badge ranking-cell"
        :style="{
          backgroundImage: `url(${require(`@/assets/icons/top${idx}.svg`)})`,
        }">
        <!-- <img class="object-none" :src="require(`@/assets/icons/top${idx}.svg`)" alt=""> -->
      </div>
    </div>
    <div class="ranking-col-2 flex-1">
      <transition-group name="flip-list" tag="div">
        <div v-for="(kpi, idx) in rankingChart" :key="kpi.department.id" class="zodiac-contender ranking-cell flex items-end">
          <div class="contender-stats flex-1">
            <p class="contender-name mb-1 font-extrabold text-xl uppercase">{{kpi.department.name}}</p>
            <div class="progress-bar relative rounded-full">
              <img class="contender-repr object-cover rounded-full absolute"
                :src="getSrc(kpi.department)" :alt="kpi.department.name">
              <div class="progress-indicator-wrapper absolute inset-0 rounded-full overflow-hidden">
                <transition appear
                  name="progress-bar-transition"
                  @before-appear="beforeAppear"
                  @appear="addProgressTransition($event, kpi)">
                  <div :key="kpi.department.id" :style="{ width: `${kpi.perf}%` }" class="progress-indicator absolute rounded-full" />
                </transition>
              </div>
              <div class="progress-text absolute mb-1">
                <transition name="text-sparkle"
                  enter-active-class="animated jello"
                  leave-active-class="animated zoomOut">
                  <img v-if="kpi.status && kpi.status === rankingStatus.UP"
                    class="absolute"
                    style="bottom: 85%; right: 95%; animation-duration: 3s"
                    :src="require(`@/assets/icons/sparkle-${idx + 1}.svg`)" />
                </transition>
                <span class="progress-perf inline-block relative mr-4">
                  <AnimatedNumber class="text-4xl font-bold"
                    :class="{
                      'text-5xl': kpi.status && kpi.status === rankingStatus.UP
                    }"
                    :value="kpi.perf"
                    :delay="1250"
                    :duration="1500"
                    :formatValue="formatWhole"
                    easing="easeInOutQuart" />
                  <AnimatedNumber class="text-2xl font-medium"
                    :class="{
                      'text-3xl': kpi.status && kpi.status === rankingStatus.UP
                    }"
                    :value="kpi.perf"
                    :delay="1250"
                    :duration="1400"
                    :formatValue="formatDecimal"
                    easing="easeInOutQuart" />
                </span>
                <span class="ranking-status inline-block w-12">
                  <transition name="ranking-status-transition" mode="out-in"
                    enter-active-class="animated tada"
                    leave-active-class="animated bounceOut">
                    <img v-if="kpi.status && kpi.status !== rankingStatus.INTACT"
                      :key="`${kpi.department.id}-${kpi.status}`"
                      :src="require(`@/assets/icons/zd-${kpi.status}-${idx + 1}.svg`)"
                      class="ranking-status-badge">
                  </transition>
                </span>
              </div>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import { mapGetters } from 'vuex'
import AnimatedNumber from "animated-number-vue"

import { RANKING_STATUS } from '../../../store'

export default {
  components: {
    AnimatedNumber,
  },
  data() {
    return {
      rankingStatus: RANKING_STATUS
    }
  },
  methods: {
    formatWhole(value) {
      return value < 100 ? parseInt(value) : 100
    },
    formatDecimal(value) {
      if(value < 100) {
        const fixed = value.toFixed(1)
        return `${fixed.substr(fixed.indexOf('.'))}%`
      }
      return '.0%'
    },
    getSrc(dep) {
      let url = null
      if(dep.avatar) {
        url = dep.avatar.url
      } else {
        const emp = dep.director
        url = (emp && emp.avatar) ? emp.avatar.url : null

      }
      return this.$zodiac.makeImage(url)
    },
    beforeAppear(el) {
      el.style.width = '0%'
      el.style.opacity = '.2'
    },
    addProgressTransition(el, kpi) {
      el.style.width = `${kpi.perf}%`
      el.style.opacity = '1'
    },
  },
  computed: {
    ...mapGetters([
      'rankingChart'
    ]),
  }
}
</script>

<style scoped>
.flip-list-move {
  transition: transform 2000ms cubic-bezier(0.23, 1, 0.320, 1);
}
.zodiac-ranking {
  --progress-bg: #d6d4d5;
  --progress-height: 1.75rem;
  --contender-repr-size: 6.5rem;
  --rank-1: #dd4639;
  --rank-2: #ff8f1a;
  --rank-3: #5cc5c1;
  --rank-4: #9bdbea;
  --rank-5: #7996d2;
}
.zodiac-contender {
  min-height: 0;
}

.contender-badge {
  width: 8rem;
  background-position: 50%;
  background-repeat: no-repeat;
}
/* 4K Screens */
@media screen and (min-width: 3840px) {
  .contender-badge {
    background-size: 175%;
  }
}

.ranking-cell {
  height: 7.5rem;
  margin-bottom: 1.75rem;
}
.contender-repr {
  width: var(--contender-repr-size);
  height: var(--contender-repr-size);
}
.contender-name {
  padding-left: calc(5% + 7rem);
}
.progress-bar {
  height: var(--progress-height);
  background-color: #d6d4d5;
  z-index: 0;
}
.progress-bar > .contender-repr {
  background-color: var(--progress-bg);
  top: 75%;
  left: 5%;
  transform: translateY(-75%);
  border-width: .4rem;
  z-index: 1;
}
.progress-bar .progress-indicator {
  top: 0;
  bottom: 0;
  left: 0;
  transform-origin: 0;
  transition: all 1500ms cubic-bezier(0.645, 0.045, 0.355, 1);
  transition-delay: 1250ms;
}
.progress-bar > .progress-text {
  bottom: 100%;
  right: 0;
}
.progress-bar > .progress-text > .progress-perf > * {
  transition: all 1.25s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.zodiac-contender:nth-child(1) .progress-bar .progress-indicator {
  background-color: var(--rank-1);
}
.zodiac-contender:nth-child(2) .progress-bar .progress-indicator {
  background-color: var(--rank-2);
}
.zodiac-contender:nth-child(3) .progress-bar .progress-indicator {
  background-color: var(--rank-3);
}
.zodiac-contender:nth-child(4) .progress-bar .progress-indicator {
  background-color: var(--rank-4);
}
.zodiac-contender:nth-child(5) .progress-bar .progress-indicator {
  background-color: var(--rank-5);
}
.zodiac-contender:nth-child(1) .progress-bar > .progress-text {
  color: var(--rank-1);
}
.zodiac-contender:nth-child(2) .progress-bar > .progress-text {
  color: var(--rank-2);
}
.zodiac-contender:nth-child(3) .progress-bar > .progress-text {
  color: var(--rank-3);
}
.zodiac-contender:nth-child(4) .progress-bar > .progress-text {
  color: var(--rank-4);
}
.zodiac-contender:nth-child(5) .progress-bar > .progress-text {
  color: var(--rank-5);
}
.zodiac-contender:nth-child(1) .progress-bar > .contender-repr {
  border-color: var(--rank-1);
}
.zodiac-contender:nth-child(2) .progress-bar > .contender-repr {
  border-color: var(--rank-2);
}
.zodiac-contender:nth-child(3) .progress-bar > .contender-repr {
  border-color: var(--rank-3);
}
.zodiac-contender:nth-child(4) .progress-bar > .contender-repr {
  border-color: var(--rank-4);
}
.zodiac-contender:nth-child(5) .progress-bar > .contender-repr {
  border-color: var(--rank-5);
}
.ranking-status-badge {
  transition-delay: 1500ms
}
</style>
